export const yearSelectors = [
  {
    selector: `#datetime-range-modal > div > div >
        div.date-range-picker-wrapper.MuiBox-root > div > div > div:nth-child(3) > 
        div.MuiGrid-root.MuiGrid-container.MuiGrid-wrap-xs-nowrap > div:nth-child(1) > 
        div > div.MuiGrid-root.MuiGrid-container > div:nth-child(3) > div > div`,
    li: `#menu- > 
    div.MuiPaper-root.MuiPaper-elevation.MuiPaper-rounded.MuiMenu-paper.MuiPaper-root.MuiPaper-elevation.MuiPaper-rounded.MuiPopover-paper
    > ul`,
  },
  {
    selector: `#datetime-range-modal > div > div >
    div.date-range-picker-wrapper.MuiBox-root > div > div > div:nth-child(3) >
    div.MuiGrid-root.MuiGrid-container.MuiGrid-wrap-xs-nowrap > div:nth-child(3) >
    div > div.MuiGrid-root.MuiGrid-container > div:nth-child(3) > div > div`,
    li: `#menu- >
    div.MuiPaper-root.MuiPaper-elevation.MuiPaper-rounded.MuiMenu-paper.MuiPaper-root.MuiPaper-elevation.MuiPaper-rounded.MuiPopover-paper
    > ul`,
  },
];
